module.exports = __webpack_public_path__ + "img/control.4e06e38c.svg";